import { FunctionalComponent, VNode, h } from '@stencil/core';
import { generateSVGImage } from 'utils/imageHelper';
import { height as iconDownHeight, svgPathData as iconDownPath, width as iconDownWidth } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { height as iconUpHeight, svgPathData as iconUpPath, width as iconUpWidth } from '@fortawesome/pro-solid-svg-icons/faCaretUp';

/**
 * Interface for a dropdown component
 * @hidden
 */
interface DropdownTriggerProps {
  ariaLabel: string;
  id: string;
  modifiers: string[];
  open: boolean;
  hasTriggerLabel?: boolean;
  clickHandler: (evt: Event) => void;
}

export const DropdownTrigger: FunctionalComponent<DropdownTriggerProps> = ({
  ariaLabel,
  id,
  modifiers,
  open,
  hasTriggerLabel,
  clickHandler,
}: DropdownTriggerProps) => {
  const classes = ['c-dropdown__selector'];
  if (modifiers.length > 0) {
    classes.push(modifiers.join(' '));
  }

  const attributes = {
    id: `${id}:button`,
    part: 'selector',
    onClick: clickHandler,
    'aria-labelledby': `${id}:list:${id}:button`,
    'aria-haspopup': 'listbox',
    'aria-expanded': open.toString(),
    'aria-label': ariaLabel,
    'data-track': 'true',
    'data-track-value': ariaLabel,
  };

  const iconPath = open ? iconUpPath : iconDownPath;
  const iconHeight = open ? iconUpHeight : iconDownHeight;
  const iconWidth = open ? iconUpWidth : iconDownWidth;

  return (
    <button class={classes.join(' ')} {...attributes}>
      {hasTriggerLabel ? (
        <span part="label" class="c-dropdown__label">
          <slot name="label" />
        </span>
      ) : null}
      {generateSVGImage({ data: iconPath, height: iconHeight, width: iconWidth }, 'c-dropdown__caret')}
    </button>
  ) as VNode;
};
